export const isProduction = () => {
    return process.env.REACT_APP_ENV === 'production';
}

export const isLocal = () => {
    return process.env.REACT_APP_ENV === 'local';
}

export const apiUrl = (process.env.REACT_APP_API_URL === undefined) ? '' : process.env.REACT_APP_API_URL;
